import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = 'pahala_token';

const api = axios.create({ baseURL: API });

function setAuthHeader(token) {
  if (token) api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  else delete api.defaults.headers.common['Authorization'];
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [mitra, setMitra] = useState([]);
  const [bootLoading, setBootLoading] = useState(true);

  // Restore session on mount
  useEffect(() => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) {
      setBootLoading(false);
      return;
    }
    setAuthHeader(token);
    api
      .get('/auth/me')
      .then((res) => {
        setUser({ role: res.data.role, ...res.data.user });
      })
      .catch(() => {
        localStorage.removeItem(TOKEN_KEY);
        setAuthHeader(null);
      })
      .finally(() => setBootLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    try {
      const res = await api.post('/auth/login', { email, password });
      const { token, role, user: u } = res.data;
      localStorage.setItem(TOKEN_KEY, token);
      setAuthHeader(token);
      setUser({ role, ...u });
      return { ok: true, role };
    } catch (e) {
      const msg = e?.response?.data?.detail || 'Login gagal. Coba lagi.';
      return { ok: false, message: msg };
    }
  }, []);

  const register = useCallback(async (data) => {
    try {
      await api.post('/auth/register', data);
      return { ok: true };
    } catch (e) {
      const msg = e?.response?.data?.detail || 'Pendaftaran gagal.';
      return { ok: false, message: typeof msg === 'string' ? msg : 'Pendaftaran gagal.' };
    }
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    setAuthHeader(null);
    setUser(null);
  }, []);

  const loadMitra = useCallback(async (status) => {
    try {
      const params = status && status !== 'semua' ? { status } : {};
      const res = await api.get('/mitra', { params });
      setMitra(res.data);
      return res.data;
    } catch (e) {
      return [];
    }
  }, []);

  const updateMitraStatus = useCallback(async (id, status) => {
    await api.patch(`/mitra/${id}/status`, { status });
  }, []);

  const deleteMitra = useCallback(async (id) => {
    await api.delete(`/mitra/${id}`);
  }, []);

  return (
    <AuthContext.Provider
      value={{ user, mitra, bootLoading, login, register, logout, loadMitra, updateMitraStatus, deleteMitra }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
